export const CorpusStatus = {
  IN_PROGRESS: "In Progress",
  SUCCESS: "Success",
  FAILED: "Failed",
} as const;

export type CorpusStatusKey = keyof typeof CorpusStatus;
export type CorpusStatusValue = (typeof CorpusStatus)[CorpusStatusKey];

export const CorpusType = {
  POLICY: "Policy",
} as const;

export type CorpusTypeKey = keyof typeof CorpusType;
export type CorpusTypeValue = (typeof CorpusType)[CorpusTypeKey];

export const CorpusStatsFields = {
  TOTAL: "total",
  SUCCESS: "success",
  FAILED: "failed",
  IN_PROGRESS: "inprogress",
} as const;

export type CorpusStatsFieldKey = keyof typeof CorpusStatsFields;
export type CorpusStatsFieldValue = (typeof CorpusStatsFields)[CorpusStatsFieldKey];

export const PaginationDefaults = {
  PAGE: 1,
  PAGE_SIZE: 10,
} as const;

export type StatValues = {
  [key in CorpusStatsFieldValue]: number;
};

export type CorpusStatsRecord = Record<string, StatValues>;
export type CorpusStats = CorpusStatsRecord;

// Table related
export interface CorpusItem {
  id: string;
  corpusName: string;
  fileType: string;
  size?: string;
  ingestionStatus: "Success" | "Failed" | "In Progress" | string;
  ingestionTime: string;
}

export interface CorpusListResponse {
  data: CorpusItem[];
  total: number;
}